import React from 'react';
import Splash from '../../components/Splash';

function Home() {
  return <Splash loading>Loading...</Splash>;
}

export default Home;
